import React from "react";

export default function TD(props) {
  return <td className={`c-table__d ${props.className}`}>{props.children}</td>;
}
